import { render, staticRenderFns } from "./AcTrans.vue?vue&type=template&id=635d952e&scoped=true"
import script from "./AcTrans.vue?vue&type=script&lang=js"
export * from "./AcTrans.vue?vue&type=script&lang=js"
import style0 from "./AcTrans.vue?vue&type=style&index=0&id=635d952e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635d952e",
  null
  
)

export default component.exports